import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loading$ = new BehaviorSubject<boolean>(false);
  private _loadingRequests = 0;
  private _loadingMessage$ = new BehaviorSubject<string>('Caricamento in corso...');

  public loading$: Observable<boolean> = this._loading$.asObservable();
  public loadingMessage$: Observable<string> = this._loadingMessage$.asObservable();

  /**
   * Avvia il loading
   */
  startLoading(message?: string): void {
    this._loadingRequests++;
    
    if (message) {
      this._loadingMessage$.next(message);
    }
    
    if (this._loadingRequests === 1) {
      this._loading$.next(true);
    }
  }

  /**
   * Ferma il loading
   */
  stopLoading(): void {
    if (this._loadingRequests > 0) {
      this._loadingRequests--;
    }
    
    if (this._loadingRequests === 0) {
      this._loading$.next(false);
      this._loadingMessage$.next('Caricamento in corso...');
    }
  }

  /**
   * Forza la fine del loading (per casi di emergenza)
   */
  forceStopLoading(): void {
    this._loadingRequests = 0;
    this._loading$.next(false);
    this._loadingMessage$.next('Caricamento in corso...');
  }

  /**
   * Verifica se è in corso un loading
   */
  isLoading(): boolean {
    return this._loading$.value;
  }

  /**
   * Imposta un messaggio personalizzato per il loading
   */
  setMessage(message: string): void {
    this._loadingMessage$.next(message);
  }

  /**
   * Metodo di test per simulare un loading manuale (per sviluppo/debug)
   */
  testLoading(duration: number = 3000, message: string = 'Test loading...'): void {
    this.startLoading(message);
    setTimeout(() => {
      this.stopLoading();
    }, duration);
  }
}
